module.exports = __webpack_public_path__ + "static/img/huaishuTopNew.4cc54bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/huaiBrand/huaishuTopNew.png
// module id = kepZ
// module chunks = 0